/**
 * Message type enumerations
 */
export const MessageType = Object.freeze({
  DEFAULT: "default",
  REFRESH_LINK: "manual-refresh-link",
  AUTO_REFRESH: "auto-refresh",
  MESSAGE_WITH_PROGRESS: "message-with-progress",
});
